<i18n>
{
  "fr": {
    "vehicle": "LE VÉHICULE",
    "brand": "Marque",
    "model": "Modèle",
    "years": "Année",
    "registration": "Immatriculation",
    "owner": "Propriétaire du vehicule",
    "driver": "Conducteur",
    "trailer": "Remorque",
    "roofBox": "Coffre de toit",
    "roofBikeRack": "Porte-vélo sur le toit",
    "rearBikeRack": "Porte-vélo arrière",
    "placeholder": "laisser vide si absent",
    "comment": "Dimenssions: Longueur x largeur x hauteur",
    "takeVehicleComment": "Prendre un véhicule",
    "required": "Champs requis"
  },
  "en": {
    "vehicle": "THE VEHICLE",
    "brand": "Brand",
    "model": "Model",
    "years": "Years",
    "registration": "Registration",
    "owner": "Vehicle Owner",
    "driver": "Driver",
    "trailer": "Trailer",
    "roofBox": "Roof box",
    "roofBikeRack": "Roof bike rack",
    "rearBikeRack": "Rear bike rack",
    "placeholder": "leave empty if not present",
    "comment": "Dimensions: Length x Width x Height",
    "takeVehicleComment": "Take a vehicle",
    "required": "Required"
  }
}
</i18n>

<template>
  <v-container>
    <div class="header-container">
      <h2
        class="title-container"
      >
        {{ $t('vehicle') }}
      </h2>
      <v-switch
        v-model="takeVehicle"
        :label="$t('takeVehicleComment')"
        color="blue"
        hide-details
        class="switch-container"
      />
    </div>
    <v-row
      v-if="takeVehicle"
    >
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="marque"
        >
          {{ $t('brand') }}
        </label>
        <v-text-field
          id="marque"
          v-model="marque"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!marque && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="modele"
        >
          {{ $t('model') }}
        </label>
        <v-text-field
          id="modele"
          v-model="modele"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!modele && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="année"
        >
          {{ $t('years') }}
        </label>
        <v-text-field
          id="année"
          v-model="annee"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          type="number"
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!annee && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="immatriculation"
        >
          {{ $t('registration') }}
        </label>
        <v-text-field
          id="immatriculation"
          v-model="immatriculation"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!immatriculation && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <v-row
      v-if="takeVehicle"
    >
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="proprietaire"
        >
          {{ $t('owner') }}
        </label>
        <v-text-field
          id="proprietaire"
          v-model="proprietaire"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!proprietaire && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="conducteur"
        >
          {{ $t('driver') }}
        </label>
        <v-text-field
          id="conducteur"
          v-model="conducteur"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!conducteur && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <v-row
      v-if="takeVehicle"
    >
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="remorque"
        >
          {{ $t('trailer') }}
        </label>
        <v-text-field
          id="remorque"
          v-model="remorque"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          :placeholder="$t('placeholder')"
          hide-details
        />
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="coffreDeToit"
        >
          {{ $t('roofBox') }}
        </label>
        <v-text-field
          id="coffreDeToit"
          v-model="coffreDeToit"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          :placeholder="$t('placeholder')"
          hide-details
        />
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="porteVeloToit"
        >
          {{ $t('roofBikeRack') }}
        </label>
        <v-text-field
          id="porteVeloToit"
          v-model="porteVeloToit"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          :placeholder="$t('placeholder')"
          hide-details
        />
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="porteVeloArriere"
        >
          {{ $t('rearBikeRack') }}
        </label>
        <v-text-field
          id="porteVeloArriere"
          v-model="porteVeloArriere"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          :placeholder="$t('placeholder')"
          hide-details
        />
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    formNotValidate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    takeVehicle: false,
    marque: '',
    modele: '',
    annee: '',
    immatriculation: '',
    proprietaire: '',
    conducteur: '',
    remorque: '',
    coffreDeToit: '',
    porteVeloToit: '',
    porteVeloArriere: ''
  }),
  methods: {
    validateCarSection () {
      if (this.takeVehicle === true) {
        return {
          brand: this.marque,
          model: this.modele,
          years: this.annee,
          registration: this.immatriculation,
          owner: this.proprietaire,
          driver: this.conducteur,
          trailer: this.remorque,
          roofBox: this.coffreDeToit,
          roofBikeRack: this.porteVeloToit,
          RearBikeRack: this.porteVeloArriere
        }
      } else {
        this.takeVehicle = false
        this.marque = ''
        this.modele = ''
        this.annee = ''
        this.immatriculation = ''
        this.proprietaire = ''
        this.conducteur = ''
        this.remorque = ''
        this.coffreDeToit = ''
        this.porteVeloToit = ''
        this.porteVeloArriere = ''
        return {}
      }
    }
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.switch-container {
  margin-bottom: 15px;
}

.error-message {
  color: red;
  font-size: 14px;
  font-style: italic;
}

.title-container {
  margin-bottom: 17px;
  font-weight: 800;
  color: #006fb9;
}

.comment-input {
  opacity: 0.35;
  margin-top: 10px;
  font-size: 13px;
}

.title-input {
  color: #006fb9;
  font-size: 18px;
  font-weight: 550;
  opacity: 0.8;
}

</style>
